import React,{Fragment,useState} from 'react';
import {v4 as uuid} from 'uuid';
import PropTypes from 'prop-types';

const Formulario = ({crearCita}) => {  
    let [cita,actualizarCita] = useState({
        mascota:'',
        propietario:'',
        fecha:'',
        hora:'',
        sintomas:''
    });

    let [isError,actualizarError] = useState(true);

    const {mascota,propietario,fecha,hora,sintomas} = cita;

    const actualizarEstado = (e) =>{
        actualizarCita({
            ...cita,[e.target.name] : e.target.value
        })
    }

    const submitCita = e=>{
        e.preventDefault();
        
        //Validar
        let validarCampos = () =>{
            for(const dato in cita){
                if(cita[dato].trim() === ''){
                    actualizarError(true);
                    return
                }
                actualizarError(false);
            }
        }

        validarCampos();
        isError === true ? console.log('Campos vacios') : console.log('Enviando...');

        if(isError)return;

        //Asignar un ID
        cita.id = uuid();
        //console.log(cita);

        //Crear cita
        crearCita(cita);
        
        //Reiniciar el form
        actualizarCita({
            mascota:'',
            propietario:'',
            fecha:'',
            hora:'',
            sintomas:''
        });

    }
    
    return (
        <Fragment>
            <h2>Crear cita</h2>

            {isError === true ? <p>Todos los campos son obligatorios</p> : null }

            <form action=""
                onSubmit={submitCita}>
                <label htmlFor="">Nombre mascota</label>
                <input type="text"
                    name="mascota"
                    className="u-full-width"
                    placeholder="Nombre mascota"
                    /* Una funcion expresiva de tipo flecha */
                    onChange={actualizarEstado}
                    value={mascota}
                />

                <label htmlFor="">Nombre del dueño de la mascota</label>
                <input type="text"
                    name="propietario"
                    className="u-full-width"
                    placeholder="Nombre del dueño de la mascota"
                    onChange={actualizarEstado}
                    value={propietario}
                />

                <label htmlFor="">Fecha</label>
                <input type="date"
                    name="fecha"
                    className="u-full-width"
                    onChange={actualizarEstado}
                    value={fecha}

                />

                <label htmlFor="">Hora</label>
                <input type="time"
                    name="hora"
                    className="u-full-width"
                    onChange={actualizarEstado}
                    value={hora}

                />

                <label htmlFor="sintomas">Síntomas</label>
                <textarea name="sintomas" 
                    id="sintomas"
                    className="u-full-width"
                    onChange={actualizarEstado}
                    value={sintomas}
                    >                        
                </textarea>

                <button type="submit"
                    className="u-full-width button-primary"
                >Agregar cita</button>
            </form>
        </Fragment>
      );
}

Formulario.propTypes = {
    crearCita: PropTypes.func.isRequired
}
 
export default Formulario;